import { isEqual } from 'lodash';
import { IFilterComparator } from '../../filter-types';

export class DefaultComparator implements IFilterComparator<any> {
  applyFilterOptions(options: number) {
    return;
  }

  hasValidDiff(grid, store): boolean {
    return !isEqual(grid, store);
  }
}
